import React, { Component } from "react";
import { connect } from "react-redux";

import Modal from '@mawesi-sas/mws_react_component_modal';
import Input from '@mawesi-sas/mws_react_component_input';

import ButtonStrip from "../../Layout/components/ButtonStrip";
import BoxButton from "../../Layout/components/BoxButton";
import Usuarios from "./Usuarios";

import {
  showHideModalCreateTipoProducto,
  guardarTipoProducto,
  filtrarTableLocally
} from "../actions";
import { showHideModalSelector } from "../../Layout/actions";

class ModalCreateTipoProducto extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tabs: [
        {
          id: 0,
          caption: "Usuarios",
          component: <Usuarios />
        }
      ],
      selected: 0
    };
  }

  selectTab = (e, tab) => {
    e.preventDefault();
    this.setState({
      selected: tab
    });
  };

  handleOnChange = value => {
    this.props.filtrarTableLocally();
  };

  modalContent = () => {
    const { tabs, selected } = this.state;
    const buttons = [];
    if (this.props.elementos.filter(x => x === "rITU6xmf").count())
      buttons.push(
        <BoxButton
          key="ba[-1][0]"
          name="check"
          title="Aceptar"
          disabled={this.props.saving}
        />
      );

    return (
      <form
        id="form"
        onSubmit={e => {
          e.preventDefault();
          this.props.guardarTipoProducto();
        }}
        noValidate
      >
        <ButtonStrip actions={buttons} />
        <div
          style={{
            width: "30vw"
          }}
        >
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label className="control-label">Nombre</label>
                <Input
                  type="text"
                  reducer="tiposervicios"
                  path="modalCreateTipoProducto.data.nombre"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label className="control-label">Valor máximo</label>
                <Input
                  type="number"
                  reducer="tiposervicios"
                  path="modalCreateTipoProducto.data.valor_maximo"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label className="control-label">Valor fijo</label>
                <Input
                  type="select"
                  reducer="tiposervicios"
                  path="modalCreateTipoProducto.data.valor_fijo"
                  options={[
                    {
                      value: 1,
                      caption: "SI"
                    },
                    {
                      value: 0,
                      caption: "NO"
                    }
                  ]}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label className="control-label">Descripción</label>
                <Input
                  type="textarea"
                  reducer="tiposervicios"
                  path="modalCreateTipoProducto.data.descripcion"
                />
              </div>
            </div>
          </div>
          <div
            style={{
              marginTop: "15px"
            }}
          >
            <div className="row">
              <div
                className="col-md-12"
                style={{
                  height: "300px"
                }}
              >
                <div
                  className="row"
                  style={{
                    height: "100%",
                    overflowX: "hidden"
                  }}
                >
                  <div
                    className="col-md-12"
                    style={{
                      height: "100%"
                    }}
                  >
                    <div className="nav-container">
                      <div className="nav-tabs-section">
                        <ul className="nav-tabs-tabs">
                          {tabs.map(x => {
                            return (
                              <li
                                key={`li02[${x.id}]`}
                                className={selected === x.id ? "active" : ""}
                              >
                                <a onClick={e => this.selectTab(e, x.id)}>
                                  {x.caption}
                                </a>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      <div className="nav-main-section">
                        <div className="">
                          <div className="buttonstrip">
                            <Input
                              type="text"
                              reducer="tiposervicios"
                              path="modalCreateTipoProducto.data.tables.users.search"
                              afterChange={this.handleOnChange}
                              placeholder="Filtrar..."
                            />
                          </div>
                        </div>
                        <div className="nav-main-section-scrollable">
                          {tabs[selected].component}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  };

  render() {
    const { modalCreateTipoProducto } = this.props;

    return (
      <Modal
        ancho="30vw"
        mostrar={modalCreateTipoProducto.get("show")}
        contenido={this.modalContent()}
        titulo="Creacion/Modificacion de tipos de producto"
        nombre="modal_create_tipo_producto"
        onCerrarModal={() => this.props.showHideModalCreateTipoProducto(false)}
      />
    );
  }
}

const mapStateToProps = (state, onwProps) => {
  return {
    modalCreateTipoProducto: state.tiposervicios.get("modalCreateTipoProducto"),
    elementos: state.layout.get("elementos")
  };
};

const mapDispatchToProps = {
  showHideModalCreateTipoProducto,
  guardarTipoProducto,
  filtrarTableLocally,
  showHideModalSelector
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalCreateTipoProducto);
